/* 🤖 this file was generated by svg-to-ts */
export const matIconCheck: {
  name: 'check';
  data: string;
} = {
  name: 'check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>`
};
